import { msg } from "@lingui/core/macro";

/**
 * Message descriptor for the "required field" validation error.
 *
 * react-hook-form rules require a plain `string`, so translate it with `t(requiredMessage)` (destructured from the `useLingui()` hook) where needed.
 */
export const requiredMessage = msg`This field is required`;
